import PropTypes from 'prop-types';
import React, { useCallback, useState } from 'react';
import { FormattedMessage } from 'react-intl';
import { makeStyles } from '@material-ui/core/styles';
import { Button } from '@material-ui/core';
import { Formik } from 'formik';
import {
  AddResourceIcon,
  ResourceRequestIcon
} from '~/modules/common/components';
import { useMenuState } from '~/modules/common/hooks';
import AllocateResourcePopup from '~/modules/resourcing/components/AllocateResourcePopup/AllocateResourcePopup';
import { useProjectContext } from '~/modules/resourcing/common/contexts';
import { useAllocateResourcePopupHandler } from '~/modules/resourcing/components/AllocateResourcePopup/hooks/useAllocateResourcePopupHandler';
import { useResourceRequestToolbarContext } from '../../../hooks';

const useStyles = makeStyles(theme => ({
  actionButton: {
    flexGrow: 0,
    flexShrink: 0,
    whiteSpace: 'nowrap',
    transition: theme.transitions.create(['opacity'], {
      easing: theme.transitions.easing.easeInOut,
      duration: theme.transitions.duration.shortest
    }),
    margin: theme.spacing(0, 2, 0, 0)
  }
}));
const startIcon = <AddResourceIcon />;
const actionButtonIcon = <ResourceRequestIcon />;

const ResourceRequestChartActions = ({
  handleAddResourceRequestClick,
  isResourceAssignmentEnabled,
  isEditProjectAllowed,
  handleAddAllocation
}) => {
  const classes = useStyles();
  const { anchorEl, onMenuClose, onMenuClick } = useMenuState();
  const { project } = useProjectContext();
  const { scale } = useResourceRequestToolbarContext();

  const [totalScheduledHours, setTotalScheduledHours] = useState(0);
  const handleClick = useCallback(
    event => {
      onMenuClick(event);
    },
    [onMenuClick]
  );

  const {
    initialValues,
    handleAdd,
    validationSchema
  } = useAllocateResourcePopupHandler({
    handleAddAllocation,
    project,
    scale
  });

  return (
    <>
      {isResourceAssignmentEnabled && (
        <>
          <Button
            className={classes.actionButton}
            size="small"
            color="primary"
            variant="text"
            onClick={handleClick}
            startIcon={startIcon}
          >
            <FormattedMessage id="resourceRequestButtons.allocateResource" />
          </Button>
          {anchorEl && (
            <Formik
              initialValues={initialValues}
              onSubmit={handleAdd}
              validate={validationSchema}
            >
              <AllocateResourcePopup
                anchorEl={anchorEl}
                onClose={onMenuClose}
                handleAdd={handleAdd}
                totalScheduledHours={totalScheduledHours}
                setTotalScheduledHours={setTotalScheduledHours}
                showAddProject={false}
                showAddUser
              />
            </Formik>
          )}
        </>
      )}
      {isEditProjectAllowed && (
        <Button
          className={classes.actionButton}
          size="small"
          color="primary"
          variant="text"
          onClick={handleAddResourceRequestClick}
          startIcon={actionButtonIcon}
        >
          <FormattedMessage id="resourceRequestButtons.requestResources" />
        </Button>
      )}
    </>
  );
};

ResourceRequestChartActions.propTypes = {
  handleAddResourceRequestClick: PropTypes.func,
  isResourceAssignmentEnabled: PropTypes.bool,
  isEditProjectAllowed: PropTypes.bool,
  handleAddAllocation: PropTypes.func
};

export default ResourceRequestChartActions;
